export * from './src/emailsubscriptions-v1-emailsubscription-email-subscriptions.universal.js';
